<template>
  <div class="home">
    <Header></Header>

    <Baner></Baner>

    <Section id="select-brand">
      <h1 class="text-center text-upper">Wybierz markę SWOJEGO SAMOCHODU</h1>
      <div class="text-center flex-row">
        <div class="flex-row flex-row--md mt--1 flex-item__lg--6 flex-item__md--7 flex-item__sm--10">
          <div class="flex-item text-center cursor-pointer brand" :class="{
            'brand--selected': lead.brand_id == brand.id,
          }" v-for="brand in getBrands" :key="brand.id" v-on:click="
            lead.brand_id = brand.id;
          lead.brand_val = brand.name;
          lead.model_id = null;
          lead.model_val = null;
          fetchModels({
            brand_id: brand.id,
          });
          ">
            <img :src="brand.image" :alt="brand.name" class="brand__image" />
          </div>
        </div>
      </div>
    </Section>

    <Section id="select-model">
      <div class="text-center flex-row flex-row--sm">
        <div class="flex-item--7"></div>
        <div class="flex-item--10">
          <span class="text-label">MODEL</span>
          <Select class="pt--1" :hideOnSelect="true">
            <template slot="value">
              <span>
                {{
                  lead.model_id && getModels.length > 0
                    ? getModels.find((e) => e.id == lead.model_id).name
                    : "Wybierz"
                }}
                {{ lead.brand_val ? lead.brand_val + " " : "" }}
              </span>
            </template>
            <span v-if="!lead.brand_id" slot="title">
              Proszę najpierw wybrać markę!
              <br />
              <a href="#select-brand">Wybierz</a>
            </span>
            <template v-else>
              <template slot="title">
                Wybierz model
                <br />
                {{ lead.brand_val ? lead.brand_val + " " : "" }}
                <Input :placeholder="'szukaj'" v-on:inputChange="modelSearchVal = $event"></Input>
              </template>
              <template slot="list">
                <ul>
                  <li v-for="model in getModels.filter((e) =>
                    e.name.toLowerCase().includes(modelSearchVal.toLowerCase())
                  )" :key="model.id" :class="{ active: lead.model_id == model.id }" v-on:click="() => {
                    lead.model_id = model.id;
                    lead.model_val = model.name;
                  }
                    ">
                    {{ model.name }}
                  </li>
                </ul>
              </template>
            </template>
          </Select>
        </div>
        <div class="flex-item--10">
          <span class="text-label">NUMER VIN</span>
          <Input :placeholder="'Wpisz'" v-on:inputChange="lead.vin = $event"></Input>
        </div>
        <div class="flex-item--10" v-if="
          lead.brand_id &&
          lead.vin &&
          lead.vin.length == 17 &&
          lead.model_id &&
          !showStep.service
        ">
          <span class="text-label">&nbsp;</span>
          <Button class="mt--1" v-on:click="showStep.service = true"> Kontynuuj </Button>
        </div>
        <div class="flex-item--7"></div>
      </div>
    </Section>
    <div class="c-section--gray">
      <Section class="c-section services" v-if="showStep && showStep.service == true">
        <h2 class="text-center text-upper">Wybierz Usługę</h2>
        <div class="flex-row flex-row--sm">
          <div class="flex-item-10 flex--middle flex--center c-service__col">
            <div>
              <h3 class="text-center text-upper">Potrzebuję serwisu</h3>
              <ul class="c-service__list">
                <li v-for="service in getServices" :key="service.id" v-on:click="pushService(service)" :class="[
                  'c-service__list-item',
                  {
                    'c-service__list-item--selected': lead.services_val.includes(
                      service.val
                    ),
                  },
                ]">
                  {{ service.text }}
                </li>
              </ul>
            </div>
          </div>
          <div class="flex-item-10 flex--middle flex--center c-service__col pointer" :class="{
            'c-service__col--selected': lead.services_val.includes(
              'Porada specjalisty'
            ),
          }" v-on:click="
            pushService({
              val: 'Porada specjalisty',
            });
          lead.services_val = lead.services_val.filter(
            (e) => e == 'Porada specjalisty'
          );
          ">
            <div>
              <h3 class="text-center text-upper">
                Nie wiem<br />jakich usług potrzebuję
              </h3>
              <p class="text-center">Porada specjalisty</p>
            </div>
          </div>
          <div class="flex-item-10 flex--middle flex--center c-service__col">
            <div>
              <h3 class="text-center text-upper">Potrzebuję Innej usługi</h3>
              <textarea placeholder="Powiadom nas o innych wymaganych usługach"
                v-on:input="lead.services_val = [$event.target.value]"></textarea>
            </div>
          </div>
        </div>
        <div class="flex-row" v-if="lead.services_val.length > 0 && !showStep.additional_options">
          <div class="flex-item flex--center">
            <div>
              <Button class="mt--1" v-on:click="showStep.additional_options = true">
                Kontynuuj
              </Button>
            </div>
          </div>
        </div>
      </Section>
      <Section class="c-section services" v-if="showStep.additional_options == true">
        <h2 class="text-center text-upper">WYBIERZ ROZWIĄZANIA DLA TWOJEJ MOBILNOŚCI</h2>
        <div class="flex-row flex-row--sm">
          <div class="flex-item flex--middle flex--center c-service__col" :class="{
            'c-service__col--selected': lead.additional_options_val.includes(
              'Odebranie samochodu od klienta / odwiezienie samochodu po naprawie'
            ),
          }" v-on:click="
            pushAdditionalOption(
              'Odebranie samochodu od klienta / odwiezienie samochodu po naprawie'
            )
            ">
            <h3 class="text-center">
              ODEBRANIE SAMOCHODU OD KLIENTA / ODWIEZIENIE SAMOCHODU PO NAPRAWIE
            </h3>
          </div>
          <div class="flex-item flex--middle flex--center c-service__col pointer" :class="{
            'c-service__col--selected': lead.additional_options_val.includes(
              'Oczekiwanie w poczekalni serwisowej'
            ),
          }" v-on:click="pushAdditionalOption('Oczekiwanie w poczekalni serwisowej')">
            <h3 class="text-center">OCZEKIWANIE W POCZEKALNI SERWISOWEJ</h3>
          </div>
          <div class="flex-item flex--middle flex--center c-service__col pointer" :class="{
            'c-service__col--selected': lead.additional_options_val.includes(
              'Dostarczenie samochodu do serwisu przez klienta'
            ),
          }" v-on:click="
            pushAdditionalOption('Dostarczenie samochodu do serwisu przez klienta')
            ">
            <h3 class="text-center">DOSTARCZENIE SAMOCHODU DO SERWISU PRZEZ KLIENTA</h3>
          </div>
          <div class="flex-item flex--middle flex--center c-service__col pointer" :class="{
            'c-service__col--selected': lead.additional_options_val.includes(
              'Samochód zastępczy'
            ),
          }" v-on:click="pushAdditionalOption('Samochód zastępczy')">
            <h3 class="text-center">SAMOCHÓD ZASTĘPCZY</h3>
          </div>
        </div>
        <div class="flex-row" v-if="!showStep.term">
          <div class="flex-item flex--center">
            <div>
              <Button class="mt--1" v-on:click="showStep.term = true"> Kontynuuj </Button>
            </div>
          </div>
        </div>
      </Section>
      <Section class="c-section services" v-if="showStep.term == true">
        <h2 class="text-center text-upper">
          PROSIMY, WYBIERZ DOGODNY DLA SIEBIE TERMIN I GODZINĘ WIZYTY
        </h2>
        <DatePicker v-model="lead.date_from" valueType="format" :lang="getDetepickerConfig"
          :disabled-date="getDetepickerConfig.range" :open="true" :append-to-body="false"
          :popup-style="{ top: 0, position: 'relative' }" v-on:change="
            fetchServiceAdmissionTerms({
              date_from: lead.date_from,
              dealer_id: lead.dealer_id,
            })
            "></DatePicker>
        <div class="flex-row flex-row--sm pt--1 c-time__wrap">
          <div class="c-time" v-for="timeOfDay in getTimeOfday" :key="'timeofday' + timeOfDay.val"
            :class="[{ 'c-time--selected': lead.visit_hour_name == timeOfDay.name }]" v-on:click="
              lead = {
                ...lead,
                ...timeOfDay.term,
                visit_hour_name: timeOfDay.name,
              };
            fetchServiceAdmissionTerms({
              date_from: lead.date_from,
              dealer_id: lead.dealer_id,
              hour_to: lead.hour_to,
              hour_from: lead.hour_from,
            });
            ">
            {{ timeOfDay.name }}
          </div>
        </div>
      </Section>
      <Section class="c-section services" v-if="getTerms.length > 0">
        <h2 class="text-center text-upper">
          Na podstawie danych wprowadzonych przez Ciebie możemy zaoferować<br />następujące
          wizyty. Kliknij, aby wybrać wizytę.
        </h2>
        <SelectBox :items="getTerms.filter((e, k) => k <= termsLimit)" class="pt--1" v-on:select="
          lead = {
            ...lead,
            date: $event.date,
            hour: $event.hour,
            visit_date_val: $event.date,
            visit_hour_val: $event.hour,
            mechanic_id: $event.mechanic_term.mechanic_id,
            mechanic_hour: $event.mechanic_term.hour_zeros,
            mechanic_date: $event.mechanic_term.date,
            user_name: $event.user_name,
            advisor_id: $event.user_id,
            repair: $event.mechanic_term,
          }
          " :selected="(e) =>
            lead.visit_date_val == e.date &&
            lead.visit_hour_val == e.hour &&
            lead.mechanic_id == e.mechanic_term.mechanic_id &&
            lead.user_name == e.user_name
            ">
          <div slot-scope="{ item }">
            <span class="c-selectBox__title">{{
              getDetepickerConfig.formatLocale.weekdaysShort[getDayofWeek(item.date)]
            }}
              {{ item.date }}</span>
            <span class="c-selectBox__subtitle">{{ item.hour_zeros }}</span>
            <span class="c-selectBox__text">Doradca serwisowy:&nbsp;{{ item.user_name }}</span>
          </div>
        </SelectBox>
        <div class="flex-row">
          <div class="flex-item--10"></div>
          <div class="flex-item--8">
            <Button class="mt--1 text-center" v-on:click="termsLimit = termsLimit == 9 ? 24 : 9" mode="white">
              {{ termsLimit == 9 ? "Pokaż więcej dostępnych wizyt" : "Pokaż mniej" }}
            </Button>
            <br />
            <Button class="mt--05" v-on:click="showStep.personal_data = true" v-if="!showStep.personal_data">
              Kontynuuj
            </Button>
          </div>
          <div class="flex-item--10"></div>
        </div>
        <div>
          <p class="text-center">
            <br />
            W przypadku chęci dokonania dodatkowych uzgodnień dotyczących terminu wizyty w
            serwisie prosimy o kontakt telefoniczny:
            <a href="+48 22 182 28 22">+48 22 182 28 22</a>
          </p>
        </div>
      </Section>
      <Section class="c-section c-form" v-if="showStep.personal_data == true">
        <h2 class="text-center text-upper">uzupełnij dane kontaktowe</h2>
        <div class="flex-row flex-row--sm">
          <div class="flex-item--10">
            <span class="text-label">IMIĘ</span>
            <Input :placeholder="'WPISZ'" v-on:inputChange="lead.first_name = $event"></Input>
          </div>
          <div class="flex-item--10">
            <span class="text-label">NAZWISKO</span>
            <Input :placeholder="'WPISZ'" v-on:inputChange="lead.last_name = $event"></Input>
          </div>
          <div class="flex-item--10">
            <span class="text-label">NUMER TELEFONU</span>

            <Input :placeholder="'WPISZ'" v-on:inputChange="lead.phone_number = $event"></Input>
          </div>
          <div class="flex-item--10">
            <span class="text-label">ADRES E-MAIL</span>

            <Input :placeholder="'WPISZ'" v-on:inputChange="lead.email = $event"></Input>
          </div>
        </div>
        <div class="flex-row flex-row--sm">
          <div class="flex-item--5"></div>
          <div class="flex-item--10">
            <span class="text-label">ADRES (ULICA NUMER)</span>

            <Input :placeholder="'WPISZ'" v-on:inputChange="lead.street_val = $event"></Input>
          </div>
          <div class="flex-item--10">
            <span class="text-label">KOD POCZTOWY</span>

            <Input :placeholder="'WPISZ'" v-on:inputChange="lead.postcode_val = $event"></Input>
          </div>
          <div class="flex-item--10">
            <span class="text-label">MIEJSCOWOŚĆ</span>
            <Input :placeholder="'WPISZ'" v-on:inputChange="lead.city_val = $event"></Input>
          </div>
          <div class="flex-item--5"></div>
        </div>
        <div class="flex-row flex-row--sm mt--2 mb--2">
          <div class="flex-item--5"></div>
          <div class="flex-item--1 pl--3 pt--1">
            <Checkbox v-on:check="lead.accept1_val = !lead.accept1_val" labelLink="accept">
            </Checkbox>
          </div>
          <div class="flex-item--10">
            <small>
              <label for="accept">
                Zgadzam się, aby podane tu przeze mnie dane zostały przetwarzane w celu
                umówienia wizyty online. Mam świadomość, że tę zgodę mogę w każdym
                momencie cofnąć na swoim profilu ze skutkiem dla przyszłości.
                <br />
                Akcentuję Ogólne Warunki Handlowe.
              </label>
              <a href="https://inchcape.pl/polityka-prywatnosci" target="_blank" rel="noopener noreferrer">
                Kliknij tutaj, aby przeczytać politykę prywatności.</a>
            </small>
          </div>
          <div class="flex-item--5"></div>
        </div>
        <div class="flex-row flex-row--sm mt--2 mb--8">
          <div class="flex-item--8"></div>
          <div class="flex-item--5">
            <a href="#summary">
              <Button class="mt--05" v-on:click="showStep.summary = true" v-if="!showStep.summary">
                Kontynuuj
              </Button>
            </a>
          </div>
          <div class="flex-item--8"></div>
        </div>
      </Section>
    </div>

    <Section class="c-section c-summary" v-if="showStep.summary" id="summary">
      <h2 class="text-center text-upper">Podsumowanie</h2>
      <div class="flex-row flex-row--sm">
        <div class="flex-item--10 c-summary__col">
          <h3 class="text-upper c-summary__header">Samochód</h3>
          <h3>{{ lead.brand_val }} {{ lead.model_val }}</h3>
          <p>
            {{ lead.vin }}
          </p>
        </div>
        <div class="flex-item--10 c-summary__col">
          <h3 class="text-upper c-summary__header">Usługa</h3>
          <p>
            {{
              [
                ...(lead.services_val
                  ? getServices
                    .filter((e) => lead.services_val.includes(e.val))
                    .map((e) => e.name)
                  : []),
                typeof lead.services_val[0] == "string" ? lead.services_val[0] : "",
              ].join(", ")
            }}
          </p>
          <hr />
          <p>
            {{ lead.additional_options_val.join(", ") }}
          </p>
        </div>
        <div class="flex-item--10 c-summary__col">
          <h3 class="text-upper c-summary__header">Termin, Godzina, Serwisant</h3>
          <div class="flex-row">
            <div class="flex-item--10">Data:</div>
            <div class="flex-item--10 text-right">
              {{ lead.visit_date_val }}
            </div>
          </div>
          <div class="flex-row">
            <div class="flex-item--10">Godzina:</div>
            <div class="flex-item--10 text-right">
              {{ lead.visit_hour_val }}
            </div>
          </div>
          <div class="flex-row">
            <div class="flex-item--10">Serwisant:</div>
            <div class="flex-item--10 text-right">
              {{ lead.user_name }}
            </div>
          </div>
        </div>
        <div class="flex-item--10 c-summary__col">
          <h3 class="text-upper c-summary__header">Dane Klienta</h3>
          <p>
            {{ lead.first_name }} {{ lead.last_name }}
            <br />
            tel.: {{ lead.phone_number }}
            <br />
            e-mail: {{ lead.email }}
          </p>
          <p>
            {{ lead.street_val }}
            <br />
            {{ lead.postcode_val }} {{ lead.city_val }}
          </p>
        </div>
      </div>
      <div class="flex-row" v-if="getErrors.length == 0">
        <div class="flex-col--10"></div>
        <div class="flex-col--10">
          <Button v-on:click="sendLead()" v-if="!getLeadResponse || getLeadResponse.status != 200">Wyślij
            zgłoszenie</Button>
        </div>
        <div class="flex-col--10"></div>
      </div>
    </Section>
    <Section class="c-section" id="contact">
      <Contact></Contact>
    </Section>
    <div class="c-footer"></div>

    <transition name="show">
      <SubmitBar v-if="(getErrors.length != 0 && getErrors.length < 4) || getLeadResponse.status == 200">
        <template v-if="!getLeadResponse">
          <span v-if="getErrors.length != 0 && getErrors.length < 4">
            <h5>Już prawie...</h5>
            <span class="ml--1">Proszę {{ getErrors.join(", ") }}</span>
          </span>
        </template>
        <template v-else>
          <div>
            <h5>Bardzo dziękujemy za Twoje zlecenie!</h5>
            <p>Wizyta pojazdu została zgłoszona.</p>
            <br />
            <p>
              <small>Szanowni Państwo,</small>
            </p>
            <p>
              <small>
                Pragniemy poinformować iż w trosce o komfort naszych Klientów zapewniamy
                możliwość bezkontaktowego pozostawienia oraz odbioru pojazdu.
                <br />
                W tym celu przygotowaliśmy dwa kluczykomaty: w wejściu głównym oraz
                bezpośrednio w strefie serwisu.
              </small>
            </p>
          </div>
        </template>
      </SubmitBar>

      <ErrorBar v-if="getLeadResponse && getLeadResponse.status != 200">
        <template>
          <div>
            <h5>{{ getLeadResponse.error }}</h5>
          </div>
        </template>
      </ErrorBar>
    </transition>
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import Contact from "@/components/Contact.vue";
import Baner from "@/components/Baner.vue";
import Section from "@/components/Section.vue";
import Select from "@/components/Select.vue";
import SelectBox from "@/components/SelectBox.vue";
import Button from "@/components/Button.vue";
import Checkbox from "@/components/Checkbox.vue";
import Input from "@/components/Input.vue";
import SubmitBar from "@/components/SubmitBar.vue";
import ErrorBar from "@/components/ErrorBar.vue";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/scss/icon.scss";
import "vue2-datepicker/scss/btn.scss";

import { mapGetters, mapActions } from "vuex";
import lead from "../mixins/lead.js";

export default {
  name: "home",
  data() {
    return {
      modelSearchVal: "",
      termsLimit: 9,
      showStep: {
        service: false,
        additional_options: false,
        term: false,
        personal_data: false,
        summary: false,
      },
    };
  },
  mixins: [lead],
  computed: {
    ...mapGetters({
      getBrands: "definitions/getBrands",
      getModels: "definitions/getModels",
      getServices: "definitions/getServices",
      getDealers: "definitions/getDealers",
      getReplacementCars: "definitions/getReplacementCars",
      getFirstPossibleDate: "definitions/getFirstPossibleDate",
      getTerms: "definitions/getTerms",
      getDetepickerConfig: "definitions/getDetepickerConfig",
      getTimeOfday: "definitions/getTimeOfDay",
      getErrors: "lead/getErrors",
      getLeadResponse: "lead/getLeadResponse",
    }),
    nextDay() {
      var date = this.getFirstPossibleDate;
      date.setHours(date.getHours());
      return date.toISOString().split("T")[0];
    },
    currentDealer() {
      let dealer = this.getDealers.find((dealer) => dealer.id == 11);
      return dealer ? dealer : null;
    },
  },
  methods: {
    ...mapActions({
      fetchDealers: "definitions/fetchDealers",
      fetchModels: "definitions/fetchModels",
      fetchServiceCars: "definitions/fetchServiceCars",
      fetchServiceAdmissionTerms: "definitions/fetchServiceAdmissionTerms",
      sendLead: "lead/sendLead",
    }),
    pushAdditionalOption(additionalOption) {
      let id = this.lead.additional_options_val.indexOf(additionalOption);
      if (id != -1) {
        this.lead.additional_options_val.splice(id, 1);
      } else {
        this.lead.additional_options_val.push(additionalOption);
      }
    },
  },
  components: {
    Header,
    Contact,
    Baner,
    Section,
    Select,
    SelectBox,
    Button,
    Checkbox,
    Input,
    DatePicker,
    SubmitBar,
    ErrorBar,
  },
  mounted() {
    this.fetchDealers({});
    if (this.$route.query.brand_id) {
      this.lead.brand_id = this.$route.query.brand_id;
    }
  },
};
</script>
<style lang="scss">
@import "../_variables.scss";

.brand {
  &--selected {
    border-bottom: 2px solid $green;
    padding-bottom: 1rem;
  }
  &__image {
    max-height: 30px;
  }
  &:first-of-type {
    .brand__image {
      max-height: 8px;
      image-rendering: pixelated;
    }
  }
}

.c-service {
  &__col {
    background-color: $white;

    padding: 1rem;
    margin: 1rem;
    min-height: 220px;
    position: relative;

    @media (min-width: 780px) {
      width: 100%;
    }

    &:hover,
    &--selected {
      &::after {
        content: " ";
        display: block;
        position: absolute;
        border: 5px solid $green;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        z-index: 1;
      }

      * {
        z-index: 2;
      }
    }
  }

  &__list {
    list-style-type: none;
    padding: 0;
    max-height: 128px;
    overflow-y: scroll;

    &-item {
      border-bottom: 1px solid $brightGray;
      text-align: center;
      padding: 0.5rem;
      margin-right: 0.1rem;
      cursor: pointer;

      &--selected {
        background-color: $ultraDarkGray;
        color: $white;
      }
    }
  }
}

.c-time {
  background-color: $white;

  margin: 1rem;
  text-align: center;
  padding: 1rem;
  cursor: pointer;
  position: relative;

  @media (min-width: 780px) {
    width: 100%;
  }

  &--selected {
    &::after {
      content: " ";
      display: block;
      position: absolute;
      border: 5px solid $green;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      z-index: 1;
    }

    * {
      z-index: 2;
    }
  }
}

.c-time__wrap {
  max-width: 1385px;
  margin: 0 auto;
}

.c-form {
  max-width: 1350px;
}

.c-footer {
  margin-top: 2rem;
  background-color: #444444;
  padding: 1rem;
  min-height: 120px;
}

.c-summary {
  &__header {
    border-bottom: 4px solid $green;
    display: block;
    width: 100%;
  }

  &__col {
    padding: 1rem;
  }
}

.mx-datepicker {
  max-width: 1350px;
  margin: 0 auto;
  background-color: $white;
}

.mx-datepicker-content {
  margin: 0 auto;
  max-width: 1000px;
  padding: 3rem 1rem;
}

.mx-input-wrapper {
  display: none;
}

.mx {
  &-input-wrapper {
    text-align: center;
  }

  &-input {
    border: 0;
    outline: none;
    font-size: 1rem;
    font-family: "Land Rover Wide";
    text-align: center;
    width: 120px;
  }

  &-calendar-content {
    width: 100%;
  }

  &-table {
    width: 100%;

    th,
    td {
      text-align: center;
      padding: 0.5rem;
    }

    td {
      cursor: pointer;
      border: 1px solid #fff;

      &:hover {
        border: 1px solid $green;
      }

      &.disabled {
        background: $ultraBrightGray;
        color: $darkGray;
        cursor: not-allowed;
      }

      &.active {
        position: relative;

        &::after {
          content: " ";
          display: block;
          position: absolute;
          border: 5px solid $green;
          left: 0;
          right: 0;
          top: 0;
          bottom: 0;
          z-index: 1;
        }

        * {
          z-index: 2;
        }
      }
    }
  }

  &-btn-text {
    border: 0;
    background: transparent;
    font-size: 1rem;
    font-family: "Land Rover Wide";
    font-weight: 100;
    padding: 0.5rem 1rem;
    margin-right: 1rem;
  }

  &-btn-current-month,
  &-btn-current-year {
    border: 1px solid $ultraBrightGray;
    background: $ultraBrightGray;

    &:hover {
      border: 1px dashed $green;
      background: transparent;
    }
  }

  &-calendar-header {
    margin-top: 1rem;

    &-label {
      text-align: center;
      margin: 0 auto;
      display: block;
    }
  }

  &-btn-icon-left,
  &-btn-icon-double-left {
    float: left;
  }

  &-btn-icon-right,
  &-btn-icon-double-right {
    float: right;
  }
}
</style>
